import { render, staticRenderFns } from "./ReadonlyViewIndividual.vue?vue&type=template&id=68d3d6ca&scoped=true"
import script from "./ReadonlyViewIndividual.vue?vue&type=script&lang=js"
export * from "./ReadonlyViewIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3d6ca",
  null
  
)

export default component.exports